import { restClient } from '@/Core'

import { DISK_ADMIN_API } from './diskAdminApi'

import type { DiskPolicy, DiskPolicyValues } from '../Contracts/DiskAdmin'

/**
 * Змінити політику: `PATCH /services/disk/admin/policy` з будь-якою
 * підмножиною ключів; відповідь — та сама, що `GET`. Ліміт тенанта сюди не
 * входить: його задає сервер (`DISK_TENANT_QUOTA_BYTES`), бек відповість 422.
 */
export const UpdateDiskPolicyTask = async (changes: Partial<DiskPolicyValues>): Promise<DiskPolicy> =>
    (await restClient.patch(`${DISK_ADMIN_API}/policy`, { json: changes })) as unknown as DiskPolicy
